/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card2_SubInputs */

const tr_landing_web_card2_sub = /** @type {(inputs: Landing_Web_Card2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryerlerinde sattığınız ürünü tek tıkla mağazanıza ekleyin. Bir kanalda satılan ürün her yerde aynı anda düşer.`)
};

const en_landing_web_card2_sub = /** @type {(inputs: Landing_Web_Card2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An item you sell on marketplaces is added to your store with one click. Sell it on any channel and stock drops everywhere at once.`)
};

const de_landing_web_card2_sub = /** @type {(inputs: Landing_Web_Card2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Artikel, den Sie auf Marktplätzen verkaufen, landet mit einem Klick im eigenen Shop. Verkauft sich etwas auf einem Kanal, sinkt der Bestand überall.`)
};

const ru_landing_web_card2_sub = /** @type {(inputs: Landing_Web_Card2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товар, который вы продаёте на маркетплейсах, добавляется в магазин одним щелчком. Продажа в любом канале списывает остаток везде сразу.`)
};

/**
* | output |
* | --- |
* | "An item you sell on marketplaces is added to your store with one click. Sell it on any channel and stock drops everywhere at once." |
*
* @param {Landing_Web_Card2_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card2_sub = /** @type {((inputs?: Landing_Web_Card2_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card2_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card2_sub(inputs)
	if (locale === "de") return de_landing_web_card2_sub(inputs)
	if (locale === "ru") return ru_landing_web_card2_sub(inputs)
	return tr_landing_web_card2_sub(inputs)
});